// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"566":"ef1d7543","728":"a969a63d","821":"7b0b0bbd"}[chunkId] + ".chunk.js";
};